import Box from '@mui/material/Box';

const BackgroundBox: React.FC = (props) => {
  return (
    <Box
      sx={{
        minWidth: '900px',
        py: 2,
      }}
    >
      {props.children}
    </Box>
  );
};

export default BackgroundBox;
